import { ENTITIES_FAIL, ENTITIES_EDIT, ENTITIES_SHOW, ENTITIES_FETCH, ENTITIES_REQUEST } from "../store/config";

const statesInit = {
	isFetching: false,
	list: [],
	pages:{
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	filters: {
		q:''
	},
	edit: {},
	permissions: [],
	detail: {},
	error: undefined,
	timestamp: null
};

const entities = (state = statesInit, action) => {
	switch(action.type) {
		case ENTITIES_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			};
		case ENTITIES_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			};
		case ENTITIES_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			};
		case ENTITIES_FETCH:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				timestamp: action.timestamp
			};
		case ENTITIES_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			};
		default:
			return {
				...state
			}

	}
};

export default entities;


// WEBPACK FOOTER //
// ./src/reducers/entities.js